/*
 * ===========================================================================
 * [StrongGate Limited] [http://www.stronggate.com]
 * Copyright (c) 2022. All rights Reserved.
 * Unauthorized access, use, dissemination, distribution, reproduction of this
 * file, or a portion of, in any form is prohibited and unlawful. If you receive
 * this file, and you are not an authorized company employee, or you believe you
 * have received this file in error, please notify the sender (or originator)
 * and promptly delete this file.
 *
 * Project:
 * File: HttpRequestGet.ts
 * Created by: Kevin
 * Create Date: 2022-12-09 18:19
 * Version Number: 1.0
 * Version Description:
 *
 * =============================================================================
 */

import {HttpRequest} from "@/commons/https/HttpRequest";
import ApiUrlBuilder from "@/commons/https/ApiUrlBuilder";
import HttpTokenProvider from "@/commons/https/HttpTokenProvider";
import HttpRequestConfig from "@/commons/https/HttpRequestConfig";
import axios from "axios";

export default class HttpRequestGet extends HttpRequest {
    private readonly uri: string;
    private readonly params: FormData | URLSearchParams | null;

    public constructor(apiUrlBuilder: ApiUrlBuilder, uri: string, cfg: HttpRequestConfig | null, params?: FormData | URLSearchParams | null) {
        super(apiUrlBuilder, cfg);
        this.uri = uri;
        this.params = params || null;
    }

    public execute(token?: HttpTokenProvider | null): Promise<any> {
        HttpTokenProvider.set(this.requestConfig, token);
        const targetURL = this.getTargetURL();
        const finalURL = this.params ? this.appendParamsAsQuery(targetURL, this.params) : targetURL;
        return new Promise((resolve, reject) => {
            axios.get(finalURL, this.requestConfig).then((res) => {
                resolve(res);
            }, (err) => {
                reject(err);
            }).catch((err) => {
                reject(err);
            })
        });
    }

    public getTargetURL(): string {
        return this.apiUrlBuilder.resolve(this.uri);
    }

    private appendParamsAsQuery(url: string, params: FormData | URLSearchParams): string {
        let queryString: string;

        if (params instanceof URLSearchParams) {
            queryString = params.toString();
        } else { // FormData
            const searchParams = new URLSearchParams();
            for (const [key, value] of params.entries()) {
                if (value instanceof File) {
                    searchParams.append(key, value.name);
                } else {
                    searchParams.append(key, value.toString());
                }
            }
            queryString = searchParams.toString();
        }

        if (!queryString) return url;

        const separator = url.includes('?') ? '&' : '?';
        return `${url}${separator}${queryString}`;
    }
}